import { z } from 'zod';

const Tags = z.object({
  eighteenCharacterInstrumentNameOfAfcNorm: z.string().nullable(),
  isin: z.string().nullable(),
  thirtyCharacterAfcNameForIssuingCompany: z.string().nullable(),
  sectorCode: z.string().nullable(),
  subSectorCode: z.string().nullable(),
  instrumentInfo: z.string().nullable(),
});

const NewsItem = z.object({
  id: z.string().nullable(),
  messageTitle: z.string().nullable(),
  messageText: z.string().nullable(),
  dateTimeOfRlcEventAsDateTime: z.string().nullable(),
  date: z.string().nullable(),
  tags: Tags.array().nullable(),
});

const NewsQuery = z.object({
  items: NewsItem.array().nullable(),
  totalCount: z.number(),
});

type NewsQuery = z.infer<typeof NewsQuery>;
type NewsItem = z.infer<typeof NewsItem>;

export { NewsQuery, NewsItem };
